import { usePaymentManager } from "../../contexts/PaymentManagerContext";
import StripePaymentGateway from "../../gateways/StripePaymentGateway/StripePaymentGateway";
import StripeMessagingElement from "../../stripe/StripeMessagingElement/StripeMessagingElement.web";
import { AffirmElementSharedProps } from "./AffirmElement.props";

/**
 * Displays UI elements related to Affirm.
 * On StripePaymentGateway, this simply displays some messaging and does not handle any actual payment
 *
 * Requires the PaymentManagerContext.
 */
function AffirmElement({ onElementReady }: AffirmElementProps) {
  const { manager } = usePaymentManager();

  if (manager.handler?.gateway instanceof StripePaymentGateway) {
    return (
      <StripeMessagingElement
        elementProps={{
          paymentMethodTypes: ["affirm"],
        }}
        onElementReady={onElementReady}
      />
    );
  }

  return null;
}

export default AffirmElement;

type AffirmElementProps = AffirmElementSharedProps;
